import React, { useEffect } from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
  CheckboxBase,
  BetaForm as useBetaForm,
} from "@reusejs/react";

let sectionHeader = {
  title: "How to use our Auction Platform",
  description:
    "Before participating in any auction event, It is recommended to go through the training video.",
};

const Video = (props: any) => {
  return (
    <div className="aspect-w-16 aspect-h-9">
      <iframe
        src="https://www.youtube.com/embed/awdUdZYQY54"
        title="AuctitonBazaar"
        frameBorder="0"
        className="rounded-lg"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default function TraingVideo(props: any) {
  const form = useBetaForm({
    training_video: false,
  });

  const form_constraints = {
    training_video: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "border-b border-gray-200 py-8",
        innerContainerStyles: "max-w-7xl mx-auto",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={
          <IconTitleDescriptionActionCard
            title={sectionHeader.title}
            description={sectionHeader.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "text-center",
              titleStyles: "text-3xl font-extrabold sm:text-4xl",
              descriptionWrapper: "text-center mt-3 sm:mt-4 max-w-2xl mx-auto",
              descriptionStyles: "text-lg text-gray-500",
            }}
          />
        }
        secondColumnEl={<Video />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full",
          secondElWrapperStyles: "w-full max-w-3xl h-full pt-4 md:pt-8",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col",
        }}
      />
      <div className="w-full flex justify-center py-4">
        <CheckboxBase
          labelBaseProps={{
            label: "I confirm that, I have completed the training video.",
          }}
          htmlFor="training_video"
          name="training_video"
          type="text"
          value={form.getField("training_video")}
          onChange={() =>
            form.setField("training_video", !form.getField("training_video"))
          }
          checkboxBaseClasses={{
            textColor: "text-blue-700",
          }}
        />
      </div>
    </SectionContainerBase>
  );
}
